module.exports = __webpack_public_path__ + "img/17_45.c5607f51.png";